import { useState, useEffect } from "react";

import { SearchOptions } from "../../models/search-options/search-options";

import { getLocalStorageValue } from "../../utils/local-storage-utils";

const useSearchOptions = (filter: string, useDeletedItems = false) => {
  const valueLS = getLocalStorageValue(filter);

  const [searchOptions, setSearchOptions] = useState<SearchOptions>({
    query: valueLS?.query ?? "",
    exactMatch: valueLS?.exactMatch ?? false,
    ...(useDeletedItems ? { deletedItems: valueLS?.deletedItems ?? false } : {}),
  });

  const handleChangeSearchOptions = (
    effect: "change" | "reset",
    field?: keyof SearchOptions,
    value?: string | boolean
  ): void => {
    if ((field === "query" && value === "") || effect === "reset")
      setSearchOptions({
        query: "",
        exactMatch: false,
        ...(useDeletedItems ? { deletedItems: false } : {}),
      });

    if (effect === "change" && field)
      setSearchOptions((state) => ({
        ...state,
        [field]: typeof value === "string" ? value.trimStart() : value,
      }));
  };

  useEffect(() => {
    localStorage.setItem(`${filter}`, JSON.stringify(searchOptions));

    return () => {
      localStorage.removeItem(`${filter}`);
    };
  }, [filter, searchOptions]);

  return { searchOptions, handleChangeSearchOptions };
};

export default useSearchOptions;
